/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_List_Filters_TitleInputs */

const en_event_list_filters_title = /** @type {(inputs: Event_List_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event List Filters`)
};

const fr_event_list_filters_title = /** @type {(inputs: Event_List_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtres de la liste d’événements`)
};

const de_event_list_filters_title = /** @type {(inputs: Event_List_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter für die Ereignisliste`)
};

const it_event_list_filters_title = /** @type {(inputs: Event_List_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtri elenco eventi`)
};

const ru_event_list_filters_title = /** @type {(inputs: Event_List_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтры списка событий`)
};

const es_event_list_filters_title = /** @type {(inputs: Event_List_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros de lista de eventos`)
};

const zh_cn2_event_list_filters_title = /** @type {(inputs: Event_List_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件列表筛选器`)
};

const ja_event_list_filters_title = /** @type {(inputs: Event_List_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントリストフィルター`)
};

const hi_event_list_filters_title = /** @type {(inputs: Event_List_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट सूची फ़िल्टर`)
};

const pt_pt2_event_list_filters_title = /** @type {(inputs: Event_List_Filters_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros da lista de eventos`)
};

/**
* | output |
* | --- |
* | "Event List Filters" |
*
* @param {Event_List_Filters_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_list_filters_title = /** @type {((inputs?: Event_List_Filters_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_List_Filters_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_list_filters_title(inputs)
	if (locale === "de") return de_event_list_filters_title(inputs)
	if (locale === "it") return it_event_list_filters_title(inputs)
	if (locale === "ru") return ru_event_list_filters_title(inputs)
	if (locale === "es") return es_event_list_filters_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_list_filters_title(inputs)
	if (locale === "ja") return ja_event_list_filters_title(inputs)
	if (locale === "hi") return hi_event_list_filters_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_list_filters_title(inputs)
	return en_event_list_filters_title(inputs)
});